

import React, { useEffect, useState } from 'react';
import { motion } from "framer-motion";
import { fadeIn } from "../variants";
import axios from 'axios';
import { Link } from 'react-router-dom';
import APIEndPoints from '../middleware/APIEndPoints';



const Work = () => {

  const [projects, setProjects] = useState([]); // State to store the fetched projects


  const getLatestProject = APIEndPoints.latestproject.url;


    // Fetch the latest two projects from the API
    useEffect(() => {
      const fetchLatestProjects = async () => {
        try {
          const response = await axios.get(getLatestProject); 
          setProjects(response.data); 
        } catch (error) {
          console.error('Error fetching latest projects:', error);
        }
      };
  
      fetchLatestProjects();
    }, []);

  return (
    <section className='section ' id='work' >
      <div className='container mx-auto'>
        <div className='flex flex-col lg:flex-row gap-x-10'>
          <motion.div
            variants={fadeIn('right', 0.3)}
            initial="hidden"
            whileInView={"show"}
            viewport={{ once: false, amount: 0.3 }}
            className='flex-1 flex flex-col gap-y-12 mb-10 lg:mb-0'>
            {/* text */}
            <div>
              <h2 className='h2 leading-tight text-accent'>
                My latest <br />
                Work
              </h2>
              <p className='max-w-sm mb-16'>
                Showcasing my latest projects in JavaScript, full-stack development, <Link to='/admin-abhijan-login' className='text-white text-xl'>a</Link>nd GUI design. Specializing in crafting intuitive and dynamic web solutions that turn ideas into engaging user experiences.
              </p>
              <Link to='/view-my-projects'>
                <button className='btn btn-sm'>View all projects</button>
              </Link>
            </div>
          </motion.div>
          <motion.div
            variants={fadeIn('left', 0.5)}
            initial="hidden"
            whileInView={"show"}
            viewport={{ once: false, amount: 0.3 }}
            className='flex-1 flex flex-col gap-y-10'>

            {projects.map((project) => (
              <div key={project._id} className='group relative overflow-hidden border-2 border-white/50 rounded-xl'>
                {/* overlay */}
                <div className='group-hover:bg-black/70 w-full h-full absolute z-40 transition-all duration-300'></div>
                <img src={project.imageSlider?.[0]?.url } alt={project.title} className='group-hover:scale-125 transition-all duration-500 h-56 w-full object-cover' />
                {/* pretitle */}
                <div className='absolute -bottom-full left-12 group-hover:bottom-24 transition-all duration-500 z-50'>
                  <span className='text-gradient'>
                    {project.category}
                  </span>
                </div>
                {/* title */}
                <div className='absolute -bottom-full left-12 group-hover:bottom-14 transition-all duration-700 z-50'>
                  <span className='text-3xl text-white'>{project.title}</span>
                </div>
              </div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Work;
